import React from 'react';

export const QUOTE_IMAGE_URL = 'https://tii.imgix.net/global/pro/QuoteMark.png';

const ProQuote = () => {
  return (
    <div className="border-0 border-b border-solid border-grayscale-beige py-24 md:py-32">
      <div className="m-auto flex flex-col sm:flex-row md:max-w-[774px]">
        <img
          className="mb-8 h-[43px] w-[45px] sm:mb-0 sm:mt-8 sm:h-[102px] sm:w-[107px]"
          src={QUOTE_IMAGE_URL}
          alt=""
        />
        <div className="sm:ml-24">
          <p className="m-0 mb-20 font-suisse-neue text-subheadline-sm text-pro-gold sm:text-subheadline-md md:text-subheadline-lg">
            There are a couple of sources for technology news, but The Information is the most
            balanced, thoughtful and complete.”
          </p>
          <p className="m-0 font-suisse-screen text-byline-lg text-grayscale-gray">
            <span className="block font-medium sm:inline-block">Chamath Palihapitiya</span> |
            Founder and CEO, Social Capital
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProQuote;
